import { ExportType, ReportType } from "PFApp/booking/types/export_booking";

import { useExportWizardModalContext } from "../export_wizard_modal_provider";
import { getTemplateReportType } from "./helpers";

interface UseReportTypeReturn {
  reportType: ReportType;
}

export const useReportType = (): UseReportTypeReturn => {
  const {
    state: {
      data: { exportType, reportType, selectedTemplate }
    }
  } = useExportWizardModalContext();
  return {
    reportType:
      exportType === ExportType.Template && selectedTemplate
        ? getTemplateReportType(selectedTemplate)
        : reportType
  };
};
